import React, { useState } from 'react';
import {
  Container,
  BackButtonContainer,
  TextWrapper,
  LogoutContainer,
  BackTextWrapper
} from './statusBarTab.style';
import { Ionicons } from '@expo/vector-icons';
import { goBack, navigate } from '../../navigation/RootNavigation';
import { TouchableOpacity, Image, View } from 'react-native';
import PopUp from '../popUp/PopupView';

import { useDispatch, useSelector } from 'react-redux';
import { removeAuthToken } from '../../redux/action/authActions';

const StatusBarTab = ({ backbutton, title }) => {
  const userToken = useSelector((state) => state?.AppReducer?.token);
  console.log('userTokenuserToken', userToken);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  return (
    <Container>
     

        <BackButtonContainer onPress={() => goBack()}>
          {backbutton ? (
            <>
              <Ionicons name="chevron-back-outline" size={24} color="#4258DB" />
              <BackTextWrapper>Back</BackTextWrapper>
            </>
          ) : null}
        </BackButtonContainer>

        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <TouchableOpacity onPress={() => navigate('home')}>
            <Image
              source={require('./../../assets/images/Logo/HubitaWeb.png')}
              style={{ height: 17, width: 150, marginRight: 20 }}
              resizeMode={'contain'}
            />
          </TouchableOpacity>
          {userToken ? (
            <TouchableOpacity onPress={() => setIsVisible(true)}>
              <LogoutContainer>{'Logout'}</LogoutContainer>
            </TouchableOpacity>
          ) : null}
        </View>
  
      <PopUp
        modalVisible={isVisible}
        titleText={'Logout?'}
        hideClose={true}
        titleColor={'#6D08C0'}
        subTitleText={'Are you sure you want to logout?'}
        subTitleColor={'black'}
        actionButtons={[
          {
            text: 'Logout',
            width: 100,
            onPress: () => {
              dispatch(removeAuthToken());
              navigate('login');
              setIsVisible(false);
            },
          },
          {
            text: 'Cancel',
            width: 100,
            onPress: () => {
              setIsVisible(false);
            },
          },
        ]}
        closePopup={() => setIsVisible(false)}
      />
    </Container>
  );
};

export default StatusBarTab;
